import { defineStore } from "pinia";
import { $fetch } from "ofetch";
import { useGetData } from "~/composables/useGetData";


export const useProdottiStoccabiliStore = defineStore("prodottiStoccabiliStore", {
  state: () => ({
    prodottiStoccabili: [],
    caricandoProdotti: false,
    errorMessage: ""
  }),
  actions: {
    async getStoccabiliOdoo() {
      const { data, getData, loading, messageError } = useGetData();
      this.caricandoProdotti = true;
      await getData("/api/stoccabili");
      if (!messageError.value) {
        this.prodottiStoccabili = data.value;
        this.caricandoProdotti = loading.value;
      } else {
        this.errorMessage = messageError;
      }
    }
  }
});
